import $ from 'jquery';

$( document ).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();

    const id = $(this).attr('href');
    const element = $(id);

    if ( ! element.length ) return;

    const header = $( '.header' ).outerHeight(true);

    const top = element.offset().top;
    $( 'body, html' ).animate({
        scrollTop: top - header,
    }, 500 );
});